export default {
  fontWeight: {
    light: "var(--font-weight-light)",
    regular: "var(--font-weight-regular)",
    medium: "var(--font-weight-medium)",
    bold: "var(--font-weight-bold)",
    "ra-light": "var(--ra-font-weight-light)",
    "ra-regular": "var(--ra-font-weight-regular)",
    "ra-medium": "var(--ra-font-weight-medium)",
    "ra-bold": "var(--ra-font-weight-bold)",
  },
  fontFamily: {
    text: "var(--font-family-text)",
    code: "var(--font-family-code)",
    emphasis: "var(--font-family-emphasis)",
    quote: "var(--font-family-quote)",
    "ra-text": "var(--ra-font-family-text)",
    "ra-code": "var(--ra-font-family-code)",
    "ra-emphasis": "var(--ra-font-family-emphasis)",
    "ra-quote": "var(--ra-font-family-quote)",
  },
  fontSize: {
    "1": "var(--font-size-1)",
    "2": "var(--font-size-2)",
    "3": "var(--font-size-3)",
    "4": "var(--font-size-4)",
    "5": "var(--font-size-5)",
    "6": "var(--font-size-6)",
    "7": "var(--font-size-7)",
    "8": "var(--font-size-8)",
    "9": "var(--font-size-9)",
    "ra-1": "var(--ra-font-size-1)",
    "ra-2": "var(--ra-font-size-2)",
    "ra-3": "var(--ra-font-size-3)",
    "ra-4": "var(--ra-font-size-4)",
    "ra-5": "var(--ra-font-size-5)",
    "ra-6": "var(--ra-font-size-6)",
    "ra-7": "var(--ra-font-size-7)",
    "ra-8": "var(--ra-font-size-8)",
    "ra-9": "var(--ra-font-size-9)",
  },
  letterSpacing: {
    "1": "var(--letter-spacing-1)",
    "2": "var(--letter-spacing-2)",
    "3": "var(--letter-spacing-3)",
    "4": "var(--letter-spacing-4)",
    "5": "var(--letter-spacing-5)",
    "6": "var(--letter-spacing-6)",
    "7": "var(--letter-spacing-7)",
    "8": "var(--letter-spacing-8)",
    "9": "var(--letter-spacing-9)",
    "ra-1": "var(--ra-letter-spacing-1)",
    "ra-2": "var(--ra-letter-spacing-2)",
    "ra-3": "var(--ra-letter-spacing-3)",
    "ra-4": "var(--ra-letter-spacing-4)",
    "ra-5": "var(--ra-letter-spacing-5)",
    "ra-6": "var(--ra-letter-spacing-6)",
    "ra-7": "var(--ra-letter-spacing-7)",
    "ra-8": "var(--ra-letter-spacing-8)",
    "ra-9": "var(--ra-letter-spacing-9)",
  },
  lineHeight: {
    "1": "var(--line-height-1)",
    "2": "var(--line-height-2)",
    "3": "var(--line-height-3)",
    "4": "var(--line-height-4)",
    "5": "var(--line-height-5)",
    "6": "var(--line-height-6)",
    "7": "var(--line-height-7)",
    "8": "var(--line-height-8)",
    "9": "var(--line-height-9)",
    "ra-1": "var(--ra-line-height-1)",
    "ra-2": "var(--ra-line-height-2)",
    "ra-3": "var(--ra-line-height-3)",
    "ra-4": "var(--ra-line-height-4)",
    "ra-5": "var(--ra-line-height-5)",
    "ra-6": "var(--ra-line-height-6)",
    "ra-7": "var(--ra-line-height-7)",
    "ra-8": "var(--ra-line-height-8)",
    "ra-9": "var(--ra-line-height-9)",
  },
};
